import { IEditScheduleState } from './editScheduleModalContext';
import { EditScheduleActionTypes, TEditScheduleAction } from '../editScheduleModalActions';

export const editScheduleReducer = (state: IEditScheduleState, action: TEditScheduleAction): IEditScheduleState => {
	switch (action.type) {
		case EditScheduleActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditScheduleActionTypes.SET_ALL_DATA:
			return {
				...state,
				scheduleID: action.payload.id,
				pushType: action.payload.type,
				schedule: action.payload.scheduledDateTime,
			};
		case EditScheduleActionTypes.CHANGE_SCHEDULE:
			return {
				...state,
				schedule: action.payload.schedule,
			};
		case EditScheduleActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditScheduleActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditScheduleActionTypes.RESET_FIELDS:
			return {
				...state,
				pushType: null,
				schedule: '',
				dataForSubmit: null,
			};
		default:
			return state;
	}
};
